import React from 'react';

const DashedLine2 = () => {
  const dashedLineStyle = {
    border: '0.1px dashed gray', // You can adjust the thickness and color of the dashed line
    width: '100%',
    height: '0',
    marginTop:'5px',
    marginBottom: '5px', // Adjust as needed
  };

  return <div style={dashedLineStyle}></div>;
};

export default DashedLine2;
